import Localization from 'lib/localization';

export default {
    lxPageBreadCrumbTitle() {
        return Localization.get('badoo_safety_center@page.search_results.not_found.title');
    },

    lxPageTitle(params: { search_query: string }) {
        const text = Localization.get('badoo_safety_center@page.search_results.page.title', params);

        return text.replace(/&apos;/g, "'");
    },

    lxPageTitleZeroCase() {
        return Localization.get('badoo_safety_center@page.search_results.not_found.title');
    },

    lxBlockTitle() {
        return Localization.get('badoo_safety_center@page.search_results.not_found.block.title');
    },

    lxBlockText() {
        return Localization.get('badoo_safety_center@page.search_results.not_found.block.text');
    },

    lxBlockListItemOne() {
        return Localization.get(
            'badoo_safety_center@page.search_results.not_found.block.list.item.one'
        );
    },

    lxBlockListItemTwo() {
        return Localization.get(
            'badoo_safety_center@page.search_results.not_found.block.list.item.two'
        );
    },

    lxBlockListItemThree() {
        return Localization.get(
            'badoo_safety_center@page.search_results.not_found.block.list.item.three'
        );
    },

    lxBlockTextNote() {
        return Localization.get(
            'badoo_safety_center@page.search_results.not_found.block.text.note'
        );
    },

    lxBlockCTA(lang: string) {
        const params = {
            // @todo: add language from props
            feedback_url: `https://badoo.com/${lang}/feedback/`,
        };
        return Localization.get(
            'badoo_safety_center@page.search_results.not_found.block.cta',
            params
        );
    },

    lxBlockCTALink(lang: string) {
        const params = {
            // @todo: add language from props
            feedback_url: `https://badoo.com/${lang}/feedback/`,
        };

        return Localization.get(
            'badoo_safety_center@page.search_results.not_found.block.cta.link',
            params
        );
    },
};
